import { createAsyncThunk } from "@reduxjs/toolkit";
import PayoffApi from "api/PayoffApi";

export const fetchPayoffs = createAsyncThunk(
  "fetchPayoffs",
  ({
    companyId,
    driverId,
    startDate,
    endDate,
  }: {
    companyId: number;
    driverId: number;
    startDate: string;
    endDate: string;
  }) => PayoffApi.fetchPayoffs(companyId, driverId, startDate, endDate)
);
